<template>
  <div>
    <el-row :gutter="20">
      <!-- 个人信息名片 -->
      <el-col :span="24">
        <el-card shadow="hover"
          style="height: 230px; margin-bottom: 20px; border: 1px solid #a0d8ff; box-shadow: 0 0 1px #a0d8ff;">


          <div style="display: flex; font-size: 16px; color: #888686">
            账号信息
          </div>

          <div class="user-info">
            <div class="user-info-cont">
              <div> </div>
              <div></div>
            </div>
          </div>

          <div style="display: flex; height: 100%; align-items: center;">
            <div style="margin-right: 20px;">
              <img class="user-avatar" :src="this.avatarUrl" alt="" />
            </div>
            
          </div>





        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20">

      <!-- 我的待办卡片 -->
      <el-col :span="12">
        <el-card shadow="hover" style="height: 400px; border: 1px solid #a0d8ff; box-shadow: 0 0 1px #a0d8ff;">
          <div style="display: flex; align-items: center; margin-bottom: 15px;">
            <i class="el-icon-document-copy" style="margin-right: 5px;"></i>
            <span style="font-size: 16px;">我的待办</span>
            <div style="margin-left: auto; display: flex; align-items: center;">
              <el-button type="text" size="mini" @click="$router.push('/messageInfo')" style="margin-right: 10px;">
                更多
              </el-button>
              <span><i class="el-icon-more"></i></span>
            </div>
          </div>
          <div style="height: 350px; overflow-x: auto; padding: 0 15px;">
            <div v-for="content in noticeContent_2" :key="content.id" style="height: 30px; margin-bottom: 10px;">
              <div>
                <div class="content-title" v-text="content.title" @click="contentClick(content.id)"></div>
                <div class="content-date" v-text="content.createTime"></div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>

      
      <!-- 我的消息卡片 -->
      <el-col :span="12">
        <el-card shadow="hover" style="height: 400px; border: 1px solid #a0d8ff; box-shadow: 0 0 1px #a0d8ff;">
          <div style="display: flex; align-items: center; margin-bottom: 15px;">
            <i class="el-icon-message" style="margin-right: 5px;"></i>
            <span style="font-size: 16px;">我的消息</span>
            <div style="margin-left: auto; display: flex; align-items: center;">
              <el-button type="text" size="mini" @click="$router.push('/messageInfo')" style="margin-right: 10px;">
                更多
              </el-button>
              <span><i class="el-icon-more"></i></span>
            </div>
          </div>

          <div style="height: 350px; overflow-x: auto; padding: 0 15px;">
            <div v-for="(content, index) in noticeContent_1" :key="index" style="margin-bottom: 15px;">
              <div class="content-title">{{ content.content }}</div>
              <div class="content-date">{{ content.createTime }}</div>
            </div>
          </div>
        </el-card>
      </el-col>

      
    </el-row>

    <div style="margin-top: 30px"></div>

  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      activeTab: "教务通知公告",
      userInfo: "",
      role: "",
      avatarUrl: "",
      city: "",
      position: {
        city: "",
        province: "",
      },
      authState: "",
      companyName: "",
      orgOptions: {},
      noticeContent_1: [],
      noticeContent_2: [],
      currPage1: 1,
      currPage2: 1,
      hasNextPage1: false,
      hasPrePage1: false,
      hasNextPage2: false,
      hasPrePage2: false,
    };
  },
  mounted() {
    //数据的初始化
    //this.drawVisitedNum();
    //this.drawAcademyNum();
    //document.querySelector('body').setAttribute('style', 'background: #f0f0f0');
    this.initBoardContent();
    this.userInfo = JSON.parse(localStorage.getItem("user"));
if (this.userInfo.status === 1001) {
      this.role = "企业用户";
    } else if (this.userInfo.status === 2001) {
      this.role = "平台运营";
    } else if (this.userInfo.status === 3001) {
      this.role = "系统管理员";
    }
    if (this.userInfo.avatar === "") {
      this.avatarUrl = require("../../assets/user_pic_middle.gif");
    } else {
      this.avatarUrl = this.userInfo.avatar;
    }

    const _this = this;
    AMap.plugin("AMap.CitySearch", function () {
      var citySearch = new AMap.CitySearch();
      citySearch.getLocalCity(function (status, result) {
        if (status === "complete" && result.info === "OK") {
          // 查询成功，result即为当前所在城市信息
          _this.position.city = result.city;
          _this.position.province = result.province;
        }
      });
    });
  },
  methods: {
    initBoardContent() {
      let user = JSON.parse(window.localStorage.getItem('user'));
      //console.log("useid: " + user.id);

      // 获取消息数据
      this.getRequest("/web/messageInfo/queryByUserId?userId=" + user.id)
        .then((resp) => {
          this.noticeContent_1 = resp.data.map(item => ({
            content: item.content,
            createTime: item.sendTime
          }));
        });
      // 


      // 原有认证状态查询
      this.getRequest("/web/companyInfo/queryAuthState?userId=" + user.id)
        .then((resp) => {
          this.authState = resp.data.authState;
          this.companyName = resp.data.companyName;
        });
    },
    avatarClick() {
      //console.log('尝试跳转到个人中心');
      if (this.$router) {
        this.$router.push('/index/center').then(() => {
          //console.log('路由跳转成功');
        }).catch(err => {
          console.error('路由跳转失败:', err);
          this.$message.error('跳转失败，请检查路由配置');
          window.location.href = '/index/center';
        });
      } else {
        console.warn('Vue Router不可用，使用原生跳转');
        window.location.href = '/index/center';
      }
    },

    contentClick(val) {
      this.$store.state.boardId = val;
      this.$router.replace("/boardDetails");
    },
    tabClick(tab) {
      this.activeTab = tab.name;
      this.initBoardContent();
    },
    changePage1(val) {
      if (val && this.hasNextPage1) {
        this.currPage1 = this.currPage1 + 1;
        this.initBoardContent();
      }
      if (!val && this.hasPrePage1) {
        this.currPage1 = this.currPage1 - 1;
        this.initBoardContent();
      }
    },
    changePage2(val) {
      if (val && this.hasNextPage1) {
        this.currPage2 = this.currPage2 + 1;
        this.initBoardContent();
      }
      if (!val && this.hasPrePage1) {
        this.currPage2 = this.currPage2 - 1;
        this.initBoardContent();
      }
    },
  },
};
</script>

<style>
.el-tabs__item {
  font-size: 16px !important;
  font-family: "monospace";
  font-weight: normal;
  text-align: left !important;
}

.el-tabs__nav-scroll {
  background-color: #f5f7fa;
}

.content-title {
  color: #777676;
  font-size: 16px;
  font-family: "sans-serif";
  margin-left: 3px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
}

.content-title:hover {
  color: #1890ff;
  cursor: pointer;
}

.content-date {
  color: #777676;
  font-size: 14px;
  float: right;
}

.icon-more {
  margin-top: -10px;
  float: right;
  color: #b44f4f;
  cursor: pointer;
  font-size: 20px;
}

.chart-card {
  overflow: auto;
}

.user-info {
  display: flex;
  align-items: center;
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: 2px solid #888686;
}

.user-info-cont {
  padding-left: 60px;
  flex: 1;
  font-size: 14px;
  color: #999;
}

.user-avatar {
  width: 120px;
  height: 120px;
  border-radius: 50%;
}

.user-info-list {
  margin-left: 50px;
}
</style>